import React, { useEffect, useState } from "react";
import NandiIcon from "../other-icons/NandiIcon";
import { getAuthStatus } from "../../helper/datalayer-utils";
import "./index.m.css";

const SubscribeBtn = () => {
  const [currentPath, setCurrentPath] = useState("/");

  useEffect(() => {
    if (typeof window !== "undefined") {
      setCurrentPath(window.location.pathname);
    }
  }, []);

  const handleSubscribe = () => {
    if (typeof window !== "undefined") {
      const { status, uuid } = getAuthStatus();
      const formattedStatus = status === "not_logged_in" ? "non_logged_in" : status;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "subscription_header_button_click",
        auth_status: formattedStatus,
        source: "DH_site",
        uuid: uuid
      });
    }
    const redirectUrl = encodeURIComponent(currentPath);
    window.location.href = `/subscribe?utm_source=top-nav&utm_medium=button&utm_campaign=subscribe&redirect_url=${redirectUrl}`;
  };

  return (
    <div styleName="subscribe-btn" onClick={handleSubscribe}>
      <NandiIcon width="21" height="15" />
      <span>Subscribe</span>
    </div>
  );
};

export default SubscribeBtn;
